import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export default function DropdownButton({ label, data, handleSelect, bgcolor }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseSelected = (selected) => {
    handleSelect(selected)
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        onClick={handleClick}
        sx={{
          bgcolor: bgcolor,
          color: '#fff',
          height: '25px',
          fontSize: '10px'
        }}>
        {label}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {data?.map(x =>
          <MenuItem key={x.name} onClick={() => handleCloseSelected(x.name)}
            sx={{
              height: '25px',
              fontSize: '10px',
            }}
          >
            {x.name}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}